import { render, staticRenderFns } from "./stuSelect.vue?vue&type=template&id=155f1db1&scoped=true"
import script from "./stuSelect.vue?vue&type=script&lang=js"
export * from "./stuSelect.vue?vue&type=script&lang=js"
import style0 from "./stuSelect.vue?vue&type=style&index=0&id=155f1db1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155f1db1",
  null
  
)

export default component.exports